import React, { Fragment, LazyExoticComponent } from "react";

import { Route, Redirect } from "react-router-dom";
import { HeaderBar } from "components/layouts";
import { useAuthSelectors } from "redux/selectors";
import { Roles } from "redux/reducers/authSlice";
import {
  expertRoutePaths,
  studentRoutePaths,
  RoutePaths,
} from "routes/RoutePaths";

interface PrivateRoutes {
  component: LazyExoticComponent<React.ComponentType<any>>;
  path: string;
  layout?: React.ComponentType<any>;
}

const PrivateRoute: React.FC<PrivateRoutes> = ({
  component: Component,
  layout,
  path,
  ...rest
}) => {
  const { selectAuthUser } = useAuthSelectors();

  const Layout = layout ? layout : Fragment;
  const isRoutePermissionAvailable = () => {
    // return true // NOTE // ! DEV-ONLY
    if (
      selectAuthUser?.currentRole === Roles.expert
      // selectAuthUser?.isExpert
      // selectAuthUser?.isVerified
    )
      return expertRoutePaths.includes(path);
    else return studentRoutePaths.includes(path);
  };

  return (
    <Route
      {...rest}
      render={(props: any) => {
        return selectAuthUser?.logged ? (
          isRoutePermissionAvailable() ? (
            <Layout>
              {/* <HeaderBar /> */}
              <Component {...props} />
            </Layout>
          ) : (
            <Redirect to={RoutePaths.root} />
          )
        ) : (
          <Redirect to={RoutePaths.login} />
        );
      }}
    />
  );
};

export default PrivateRoute;
